var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.component)?_c(_vm.component,{tag:"component",attrs:{"is-disabled":_vm.disableState,"v":_vm.v,"value":_vm.formValue,"legend-tag":_vm.htmlTag,"start-update":_vm.updateField,"field":_vm.fieldData},model:{value:(_vm.formValue),callback:function ($$v) {_vm.formValue=$$v},expression:"formValue"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }